module.exports = __webpack_public_path__ + "public/images/kakao.5388f649ca5706f00fed7959ba682bf1.webp";